import { Table } from 'antd';
import { CustomTableProps } from './CustomTableProps';
import styles from "./CustomTable.module.scss";


const CustomTable = <T,>(props: CustomTableProps<T>) => {
    const {
        columns,
        data,
        pagination,
        buttons,
        onChangePagination,
        onChange,
        locale,
        totalItems,
        loading = false,
        rowKey,
        scroll = { x: 'max-content' },
        pageSizeOptions = ['8', '16', '24', '32', '64', '100'],
        simplePagination = true,
        variant = 'default',
    } = props;

    const wrapperClassName = [
        styles.tableWrapper,
        variant === 'callbackRequests' ? styles.callbackRequests : '',
    ].filter(Boolean).join(' ');

    return (
        <>
            {buttons}
            <div className={wrapperClassName}>
                <Table<T>
                    className={styles.table}
                    columns={columns}
                    dataSource={data}
                    loading={loading}
                    rowKey={rowKey}
                    tableLayout="fixed"
                    onChange={onChange}
                    locale={locale}
                    scroll={scroll}
                    pagination={{
                        pageSize: pagination.pageSize,
                        showSizeChanger: true,
                        pageSizeOptions,
                        current: pagination.currentPage,
                        total: totalItems,
                        simple: simplePagination,
                        onChange: (page, pageSize) => {
                            if (pageSize !== pagination.pageSize) {
                                pagination.changePageSize(pageSize, page);
                            } else if (page !== pagination.currentPage) {
                                pagination.changeCurrentPage(page);
                            }
                            onChangePagination?.(pageSize, page);
                        },
                    }}
                />
            </div>
        </>
    );
}

export default CustomTable;
